module.exports = __webpack_public_path__ + "static/img/send.9409ac04.svg";